import { useTranslation } from 'next-i18next';

import { MUTED_GRAY, NOPING_GREEN, TICKER_STATS } from '../constants';

export function StatsTicker() {
  const { t } = useTranslation('components/trial/lp/v1c');
  const tripled = [...TICKER_STATS, ...TICKER_STATS, ...TICKER_STATS];

  return (
    <div className='relative overflow-hidden border-y border-white/5 bg-[#0B0B0E] py-5'>
      <div className='eu-ticker flex gap-16 whitespace-nowrap px-8'>
        {tripled.map((stat, i) => (
          <div key={`${stat.label}-${i}`} className='flex shrink-0 items-center gap-2.5'>
            <span className='font-mono text-xl font-bold tabular-nums md:text-2xl' style={{ color: NOPING_GREEN }}>
              {stat.value}
            </span>
            <span className='text-xs font-medium uppercase tracking-wider' style={{ color: MUTED_GRAY }}>
              {t(stat.label)}
            </span>
          </div>
        ))}
      </div>

      <div className='pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-[#0B0B0E] to-transparent' />
      <div className='pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-[#0B0B0E] to-transparent' />

      <style>{`
        @keyframes euTicker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .eu-ticker {
          animation: euTicker 30s linear infinite;
        }
        /* transform is physical — CSS never mirrors it for writing direction. The items overflow the
           track to the right in LTR and to the LEFT under the dir="rtl" that /sa inherits from <html>,
           so there the negative shift uncovers the right edge of the clip box instead of feeding it.
           The content is tripled, so the loop travels a third. Only animation-name is overridden. */
        @keyframes euTickerRtl {
          0% { transform: translateX(0); }
          100% { transform: translateX(33.333%); }
        }
        [dir='rtl'] .eu-ticker {
          animation-name: euTickerRtl;
        }
      `}</style>
    </div>
  );
}
